import HeaderDesktopView from "./HeaderDesktopView";
import HeaderMobileView from "./HeaderMobileView";
import "../../variables.css";
import headerLogo from "../../assets/WEBLOGO.webp";
import { Link } from "react-router-dom";
import { FaShoppingCart, FaTools } from "react-icons/fa";

const Header = () => {
  return (
    <header className="sticky top-0 z-40 bg-[var(--website-primary-color)] text-white">
      <div className="mx-auto max-w-[1536px] px-4">
        <div className="flex h-20 items-center md:h-24">
          <HeaderMobileView />
          <div>
            <Link to="/">
              <img
                src={headerLogo}
                alt="Quantarock"
                className="h-auto w-64 cursor-pointer md:w-72"
                width={337}
                height={121}
              />
            </Link>
          </div>
          <HeaderDesktopView />
          <div className="ml-auto flex items-center justify-end gap-2 sm:gap-3">
            <a
              href="https://tools.quantarock.in"
              target="_blank"
              rel="noopener noreferrer"
              className="relative inline-flex items-center justify-center rounded-md bg-[var(--website-secondary-color)] px-4 py-2.5 text-sm font-bold text-[var(--on-secondary)] shadow transition hover:bg-white sm:text-base"
            >
              <span className="block sm:hidden">
                <FaTools />
              </span>
              <span className="hidden sm:inline">Tools</span>
              <span className="absolute -right-2 -top-2 rounded-full bg-[#fbbf24] px-1.5 py-0.5 text-[10px] font-extrabold uppercase leading-none tracking-wide text-[var(--website-primary-color)] shadow ring-2 ring-[var(--website-primary-color)]">
                Free
              </span>
            </a>
            <a
              href="https://www.interseller.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-md bg-white px-4 py-2.5 text-sm font-bold text-black shadow transition hover:bg-[var(--website-secondary-color)] sm:text-base"
            >
              <span className="block sm:hidden">
                <FaShoppingCart />
              </span>
              <span className="hidden sm:inline">Visit Shop</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
